import React from 'react'
import { Store, Camera, Star } from 'lucide-react'
import { useTranslation } from 'i18n'
import { formatStepImageUrl } from 'util/beaker2-step-image-url'
import type { ProductScanConfig, SplashStepIcon } from '../config'
// @ts-expect-error SCSS modules are untyped in this project
import * as styles from '../product-scan.module.scss'

const ICON_COMPONENT: Record<SplashStepIcon, typeof Store> = { find: Store, scan: Camera, spin: Star }

const SplashScreen = ({
  config,
  onStart,
}: {
  config: ProductScanConfig
  onStart: () => void
}) => {
  const { t } = useTranslation('productScan')

  return (
    <div className={styles.step}>
      {config.headerImageId && (
        <img className={styles.headerImage} src={formatStepImageUrl(config.headerImageId)} alt="" />
      )}
      {config.headline && <h2 className={styles.headline}>{config.headline}</h2>}
      {config.introCopy && <p className={styles.introCopy}>{config.introCopy}</p>}

      {config.splashSteps.length > 0 && (
        <ol className={styles.splashSteps}>
          {config.splashSteps.map((step, i) => {
            const Icon = ICON_COMPONENT[step.icon] || Store
            return (
              <li key={`${step.title}-${i}`}>
                {/* The whole row opens the scanner, same as the CTA below — a real button so it
                    is focusable and Enter/Space work without extra key handling. */}
                <button type="button" className={styles.splashStepRow} onClick={onStart}>
                  <span className={styles.splashStepIcon} aria-hidden="true">
                    <Icon size={18} strokeWidth={2} />
                  </span>
                  <span className={styles.splashStepText}>
                    <span className={styles.splashStepTitle}>{step.title}</span>
                    <span>{step.description}</span>
                  </span>
                </button>
              </li>
            )
          })}
        </ol>
      )}

      <button type="button" className={styles.cta} onClick={onStart}>
        {config.splashCtaText || t('splashCtaText')}
      </button>
    </div>
  )
}

export default SplashScreen
